import lodashDebounce from 'lodash.debounce'

export function Debounce(delay: number) {
  return (target: any, prop: string) => {
    return {
      configurable: true,
      enumerable: false,
      value: lodashDebounce(target[prop], delay)
    };
  }
}
